import { Router } from '@okapi/router-react';
import React from 'react';
import { StoreContext } from 'storeon/react';
import { Baseline } from 'common/components';
import { KitchenPdp } from 'landings';
import { RemoteProps } from './widgets-types';

export const KitchenPdpRemote: React.FC<RemoteProps> = ({ router, store }) => (
  /* @ts-expect-error: Router typecheck error */
  <Router router={router}>
    <Baseline>
      <StoreContext.Provider value={store}>
        <KitchenPdp />
      </StoreContext.Provider>
    </Baseline>
  </Router>
);
